import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, errMsg, useSeo } from "../lib/api";
import { useAuth } from "../lib/store";
import { Page } from "../components/site/Bits";

import { useSpamProtection } from "../components/site/SpamProtection";

const Inp = ({ label, ...p }) => <label className="text-sm font-semibold flex flex-col gap-1">{label}<input {...p} className="h-12 border border-[#E6DFD5] bg-white px-3 font-normal" /></label>;

function Shell({ title, children }) {
  return <Page className="max-w-md"><h1 className="text-4xl font-black mb-8">{title}</h1>{children}</Page>;
}

export function Login() {
  const spam = useSpamProtection();
  const { setUser } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [forgot, setForgot] = useState("");
  useSeo("Anmelden");
  const submit = async (e) => {
    e.preventDefault();
    if (busy || !spam.ready) return;
    setBusy(true);
    setErr("");
    try {
      const r = await api.post("/auth/login", { ...f, turnstile_token: spam.token });
      setUser(r.data);
      nav("/admin");
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      spam.reset();
      setBusy(false);
    }
  };
  const reset = async () => {
    if (!f.email.includes("@")) return setErr("Für einen Zugang ohne E-Mail wende dich bitte direkt an René, wenn du dein Passwort vergessen hast.");
    if (busy || !spam.ready) return;
    setBusy(true);
    try {
      const r = await api.post("/auth/forgot-password", { email: f.email, turnstile_token: spam.token });
      setForgot(r.data.message);
    } catch (e) { setErr(errMsg(e)); } finally { spam.reset(); setBusy(false); }
  };
  return (
    <Shell title="Anmelden">
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <Inp label="E-Mail oder Benutzername" type="text" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} autoComplete="username" data-testid="login-email" />
        <Inp label="Passwort" type="password" required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} autoComplete="current-password" data-testid="login-password" />
        {spam.widget}
        {err && <p className="text-sm text-[#c2181d] font-semibold" role="alert" data-testid="login-error">{err}</p>}
        <button disabled={busy || !spam.ready} className="btn-ink h-12 w-full font-semibold" data-testid="login-submit">{busy ? "…" : "Anmelden"}</button>
        <button type="button" disabled={busy || !spam.ready} onClick={reset} className="text-sm underline" data-testid="forgot-password">Passwort vergessen?</button>
        {forgot && <p className="text-sm bg-[#FFF9E6] p-3" data-testid="forgot-message">{forgot}</p>}
      </form>
      <p className="text-xs text-[#6E6B65] mt-8">Deinen persönlichen Zugang bekommst du von René. <Link to="/" className="underline">Zur Website</Link></p>
    </Shell>
  );
}

export function SetPassword({ invite }) {
  const spam = useSpamProtection();
  const [busy, setBusy] = useState(false);
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  useSeo(invite ? "Einladung annehmen" : "Passwort zurücksetzen");
  const submit = async (e) => {
    e.preventDefault();
    if (busy || !spam.ready) return;
    if (pw.length < 10) return setErr("Mindestens 10 Zeichen.");
    if (pw !== pw2) return setErr("Passwörter stimmen nicht überein.");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token: sp.get("token"), password: pw, turnstile_token: spam.token });
      const me = await api.get("/auth/me");
      setUser(me.data);
      nav("/admin");
    } catch (e2) {
      setErr(errMsg(e2));
    } finally { spam.reset(); setBusy(false); }
  };
  return (
    <Shell title={invite ? "Willkommen! Passwort festlegen" : "Neues Passwort"}>
      <form onSubmit={submit} className="space-y-4" data-testid="set-password-form">
        <Inp label="Neues Passwort (min. 10 Zeichen)" type="password" value={pw} onChange={(e) => setPw(e.target.value)} autoComplete="new-password" data-testid="new-password" />
        <Inp label="Wiederholen" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} autoComplete="new-password" data-testid="new-password-2" />
        {spam.widget}
        {err && <p className="text-sm text-[#c2181d] font-semibold" role="alert">{err}</p>}
        <button disabled={busy || !spam.ready} className="btn-ink h-12 w-full font-semibold" data-testid="set-password-submit">Speichern</button>
      </form>
    </Shell>
  );
}


